export default "__VITE_ASSET__Bhu$FPRb__"